import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useLeague from '../hooks/useLeague';
import { useNavigate } from 'react-router-dom';

const LeagueInvite = () => {
    const navigate = useNavigate();
    const { currentLeague, loading, initialLoading, error, getLeagueByInviteCode, joinLeague } = useLeague();
    const { inviteId } = useParams();
    const [leagueInfo, setLeagueInfo] = useState(null);

    useEffect(() => {
        if (inviteId) {
            const fetchLeagueInfo = async () => {
                const data = await getLeagueByInviteCode(inviteId);
                if (data.success) {
                    setLeagueInfo(data.league);
                }
            };
            fetchLeagueInfo();
        }
    }, [inviteId]);

    const handleJoinLeague = async () => {
        if (leagueInfo) {
            const data = await joinLeague(leagueInfo.leagueId);
            if (data.success) {
                // If successful, navigate to the league page
                navigate(`/league`);
            }
        }
    };

    return (
        <div className="main-container col-10 offset-1">
            {initialLoading && (
                <div className="loader"></div>
            )}

            {!initialLoading && (
                <div className="league-invite-main-container">
                    <div className="league-invite-container">
                        <h2 className='title'>League Invitation</h2>
                        <div className='league-invite-inner'>
                            {error && <p className="error">{error}</p>}
                            {!error && (
                                <>
                                    <div className='league-invite-details' style={{ gap: '0.5vw', width: '100%' }}>
                                        <div className='eventpage-desc-table-container' style={{ marginBottom: '0', width: '80%' }}>
                                            <div className='profile-stats-table-container' style={{ width: '100%', height: '100%', margin: '0' }}>
                                                <table className='profile-stats-table' style={{ height: '100%' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td>Name: </td>
                                                            <td>{leagueInfo?.name}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Members: </td>
                                                            <td>{leagueInfo?.memberCount}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Created: </td>
                                                            <td>{new Date(leagueInfo?.createdAt).toLocaleDateString()}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Owner: </td>
                                                            <td className='league-user-hoverable' onClick={() => navigate(`/profile/${leagueInfo?.owner.userNumber}`)}>{leagueInfo?.owner.username}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className='eventpage-desc-table-container' style={{ marginBottom: '0', width: '100%' }}>
                                            <div className='profile-stats-table-container' style={{ width: '100%', margin: '0' }}>
                                                <table className='profile-stats-table' style={{ height: '100%' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td>Description: <span style={{ fontWeight: 'normal', fontStyle: 'italic' }} >{leagueInfo?.description}</span></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='league-invite-actions'>
                                        <button className='default-button big' { ...loading || currentLeague && { disabled: true }} onClick={handleJoinLeague}>
                                            {loading ? <div className="loader-small" /> : currentLeague && currentLeague._id === leagueInfo?.leagueId ? 'Already Joined' : currentLeague ? 'Leave your current league before joining a new one' : 'Join League'}
                                        </button>
            
                                    </div>
                                </>
                            )}
                        </div>
                        {/* Invite friends form or component goes here */}
                    </div>
                </div>
            )}

        </div>
    );
}

export default LeagueInvite;